module.exports = __webpack_public_path__ + "img/hodinky.134c3d8e.svg";